import { c as _c } from "react/compiler-runtime";
import { H5 } from '@/components/Core/Heading';
import { VimeoPlayer } from '@/components/Molecules/VimeoPlayer/VimeoPlayer';
import useTranslation from '@/hooks/useTranslation';
import type { IEmbeddedVideo } from '@/interfaces';
import type { ElementType } from 'react';
import styled from 'styled-components';
interface IProps {
  /** The video object */
  video: IEmbeddedVideo;
  /** Styled component modifier */
  as?: ElementType<any>;
}
const StyledContainer = styled.figure`
    > *:not(:last-child) {
        display: block;
        margin-bottom: var(--size-grid-half);
    }
    > figcaption {
        font-style: italic;
    }
    break-inside: avoid;
`;
export const EmbeddedVideo = t0 => {
  const $ = _c(15);
  const {
    video,
    as: t1
  } = t0;
  const as = t1 === undefined ? null : t1;
  const {
    t
  } = useTranslation();
  let embed;
  switch (video.provider) {
    case "Vimeo":
      {
        let t2;
        if ($[0] !== video.id) {
          t2 = <VimeoPlayer videoId={video.id} />;
          $[0] = video.id;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        embed = t2;
      }
  }
  let t2;
  if ($[2] !== as || $[3] !== video.title) {
    t2 = video.title && <H5 as={as}>{video.title}</H5>;
    $[2] = as;
    $[3] = video.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== video.description) {
    t3 = video.description && <figcaption>{video.description}</figcaption>;
    $[5] = video.description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t || $[8] !== video.source) {
    t4 = video.source && <figcaption>{t("Common.source", {
        source: video.source
      })}</figcaption>;
    $[7] = t;
    $[8] = video.source;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== embed || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <StyledContainer>{t2}{embed}{t3}{t4}</StyledContainer>;
    $[10] = embed;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};